import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPatchRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  ISegmentsResponseSchema,
  ISegmentsSubmitSchema,
} from "./segmentsAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllSegmentsAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: ISegmentsResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.SEGMENTS, searchParams, signal });

const getSingleSegmentsAPI = (
  id: string
): Promise<{ data: ISegmentsResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.SEGMENTS}/${id}`,
  });

const createSegmentsAPI = (
  data: Omit<ISegmentsSubmitSchema, "id">
): Promise<{ data: ISegmentsResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.SEGMENTS, data });

const updateSegmentsAPI = (
  data: Required<Pick<ISegmentsSubmitSchema, "id">> &
    Partial<ISegmentsSubmitSchema>
): Promise<{ data: ISegmentsResponseSchema }> =>
  handleGlobalPatchRequest({ url: `${URLS.SEGMENTS}/${data.id}`, data });

const deleteSegmentsAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.SEGMENTS}/${id}` });

export {
  getAllSegmentsAPI,
  getSingleSegmentsAPI,
  createSegmentsAPI,
  updateSegmentsAPI,
  deleteSegmentsAPI,
};
